<template>
    <div class="confirmation-window">
        <div class="confirmation-window__modal-content">
            <div class="confirmation-window__modal-header">
                <button
                    class="confirmation-window__modal-close close"
                    @click="$store.dispatch('closeConfirmationWindow')"
                >
                    <span>×</span>
                </button>
                <div class="confirmation-window__modal-title">
                    <h2
                        v-text="confirmationWindowConfig.header || 'Uwaga!'"
                        class="h3 m-0 p-0"
                    />
                    <h3
                        v-if="confirmationWindowConfig.subheader"
                        v-text="confirmationWindowConfig.subheader"
                        class="h5 px-2 pt-2"
                    />
                </div>
            </div>
            <page-preloader mode="wrapper" :is-loading="isConfirmationWindowLoading">
                <template
                    v-if="isConfirmationWindowLoading && confirmationWindowConfig.confirmationWindowLoadingText"
                    v-slot:loaderDescription
                >
                    <div class="py-4">
                        <h5 v-text="confirmationWindowConfig.confirmationWindowLoadingText" />
                    </div>
                </template>
                <div class="confirmation-window__modal-body">
                    <div v-html="confirmationWindowConfig.message || 'Czy potwierdzasz operację?'" />

                    <div class="confirmation-window__buttons">
                        <button
                            class="btn btn-outline-custom m-1 confirmation-window__button"
                            data-dismiss="modal"
                            @click="onAbort"
                        >
                            {{ confirmationWindowConfig.abortButtonText || 'Anuluj' }}
                        </button>
                        <button
                            class="btn btn-secondary m-1 confirmation-window__button"
                            data-dismiss="modal"
                            @click="onConfirm"
                        >
                            {{ confirmationWindowConfig.confirmButtonText || 'Potwierdź' }}
                        </button>
                    </div>
                </div>
            </page-preloader>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        confirmationWindowConfig() {
            return this.$store.getters.confirmationWindowConfig
        }
    },
    methods: {
        async onAbort() {
            if (this.confirmationWindowConfig.abortButtonCallback) {
                this.isConfirmationWindowLoading = true
                await this.confirmationWindowConfig.abortButtonCallback()
                this.isConfirmationWindowLoading = false
            }
            this.$store.dispatch('closeConfirmationWindow')
        },
        async onConfirm() {
            if (this.confirmationWindowConfig.confirmButtonCallback) {
                this.isConfirmationWindowLoading = true
                await this.confirmationWindowConfig.confirmButtonCallback()
                this.isConfirmationWindowLoading = false
            }
            this.$store.dispatch('closeConfirmationWindow')
        }
    },
    data() {
        return {
            isConfirmationWindowLoading: false
        }
    }
}
</script>

<style lang="scss">
.confirmation-window {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100vw;
        height: 100vh;
        background-color: #155a30;
        opacity: 0.5;
    }

    &__modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
        max-width: 480px;
        margin: auto;
    }

    &__modal-header {
        flex-direction: column;
        align-items: center;
        overflow-x: hidden;
        text-align: center;
        border: 0;
        display: flex;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e0e9ed;
        border-top-left-radius: calc(0.3rem - 1px);
        border-top-right-radius: calc(0.3rem - 1px);
    }

    &__modal-close {
        padding: inherit !important;
        margin: inherit;
        position: absolute;
        right: 0;
        top: 0;
    }

    &__modal-title {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        margin-bottom: 0;
        line-height: 1.5;
    }

    &__modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 1rem;
        color: var(--color-primary);
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    &__buttons {
        display: flex;
        justify-content: center;
        gap: 0.5rem;

        button {
            width: 100%;
        }
    }
}
</style>